import { Component, OnInit } from '@angular/core';
import { OnboardingLpService } from '../onboarding-lp.service';

import { UserService } from 'src/app/services/shared/user.service';
import { ResourceService } from 'src/app/services/resource.service';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { CountryModel } from 'src/app/shared/models/CountryModel';
import { Router } from '@angular/router';
import { RoutingService } from 'src/app/services/routing.service';
import { LpUserDataService } from 'src/app/services/lp/lp-user-data.service';

@Component({
  selector: 'terra-onboarding-lp-personal-details',
  templateUrl: './onboarding-lp-personal-details.component.html',
  styleUrls: ['./onboarding-lp-personal-details.component.scss']
})
export class OnboardingLpPersonalDetailsComponent implements OnInit {

  accountDetails$ = this.onboardingService.accountDetails$;

  pageForm = this.onboardingService.personalDetailsForm;
  isSubmitted = false;
  formSubmitting = false;
  isGeneralServerError = false;
  generalServerErrorMessage = TerraUtils.consts.messages.GENERAL_SUBMIT_ERROR;

  allCountries = this.resourceService.allCountries;
  allStates = this.resourceService.allStates;
  countryCodes = TerraUtils.consts.countryCode;
  USCountryId = this.resourceService.getCountryByCode(this.countryCodes.US).id;

  constructor(
    private onboardingService: OnboardingLpService,
    private resourceService: ResourceService,
    private router: Router,
    private routingService: RoutingService,
    private lpUserDataService: LpUserDataService) { }

  ngOnInit() {
  }

  nextStep(isOrganization: boolean) {
    this.isSubmitted = true;
    if (this.pageForm.valid) {
      this.isGeneralServerError = false;
      if (isOrganization) {
        this.router.navigateByUrl(this.routingService.lpOnboardingPageOrganizationDetails);
      } else {
        this.formSubmitting = true;
        this.onboardingService.submitForm()
          .subscribe(accountDetails => {
            this.lpUserDataService.createOpportunityCampaignContact(accountDetails);
            setTimeout(() => {
              this.routingService.goToReturnUrl(this.routingService.lpHomePage);
            }, 1000);
          },
            error => {
              this.formSubmitting = false;
              this.isGeneralServerError = true;
            });
      }
    }
  }

  conutryTrackByFn(index, item: CountryModel) {
    return index; // or item.id
  }

  swtichAccountTypeToOrganization() {
    if (this.formSubmitting) {
      return;
    }

    this.formSubmitting = true;
    this.lpUserDataService.switchToOrganization().subscribe(() => {
      document.location.reload();
    },
      error => {
        console.log(error);
        this.formSubmitting = false;
      });
  }

  swtichAccountTypeToIndividual() {
    if (this.formSubmitting) {
      return;
    }

    this.formSubmitting = true;
    this.lpUserDataService.switchToIndividual().subscribe(() => {
      document.location.reload();
    },
      error => {
        console.log(error);
        this.formSubmitting = false;
      });
  }
}
